import { ReviewSliderItemInterface } from '@/types/newTypes'
import React from 'react'
import { Swiper, SwiperSlide } from 'swiper/react'
import { EffectCreative, Navigation, Pagination } from 'swiper/modules'
import 'swiper/css'
import 'swiper/css/navigation'
import 'swiper/css/pagination'
import 'swiper/css/effect-creative'

const ReviewSlider = () => {
  const items: ReviewSliderItemInterface[] = [
    {
      quotesColor: '#ff3e2d',
      review:
        'Such a great find! I downloaded this app to free up space because I had way too many photos. It turned out to be a super fun and easy way to clean up my phone and get rid of all the pics I don’t need!',
      author: {
        img: '/img/reviews/1.png',
        text: 'asawvr',
      },
      publishedAt: '09/02/2024',
      gradientBg:
        'radial-gradient(58.53% 42.11% at 16.84% 39.79%, rgba(253, 148, 141, 0.3) 0%, rgba(211, 58, 48, 0) 100%), radial-gradient(155.08% 116.29% at 11.17% 95.21%, rgba(211, 58, 48, 0.3) 0%, rgba(211, 58, 48, 0.48) 49.53%, rgba(211, 58, 48, 0) 100%), rgba(255, 255, 255, 0.08)',
    },
    {
      quotesColor: '#5c73ff',
      review:
        'Honestly, this app made cleaning up my photos so easy and kinda fun! I sorted through over 5,000 pics in no time, and the swipe feature is a game-changer. Plus, it saves your progress if you leave. Super handy!',
      author: {
        img: '/img/reviews/2.png',
        text: 'awesome_Alisha',
      },
      publishedAt: '08/12/2023',
      gradientBg:
        'radial-gradient(76.84% 52.85% at 2.92% 50%, rgba(193, 147, 253, 0.6) 0%, rgba(110, 70, 255, 0) 100%), radial-gradient(155.08% 116.29% at 11.17% 95.21%, rgba(70, 81, 255, 0.6) 0%, rgba(82, 78, 255, 0.48) 30.94%, rgba(110, 70, 255, 0) 100%), rgba(255, 255, 255, 0.08)',
    },
    {
      quotesColor: '#56e499',
      review:
        'I’m usually terrible at organizing my photos, but this app made it super simple. It’s really easy to use, and the swipe feature makes decisions quick. Tons of cool features too. Highly recommend!',
      author: {
        img: '/img/reviews/3.png',
        text: 'Edwardddddd91',
      },
      publishedAt: '01/07/2024',
      gradientBg:
        'radial-gradient(76.84% 52.85% at 2.92% 50%, rgba(118, 207, 162, 0.4) 0%, rgba(61, 170, 115, 0) 100%), radial-gradient(155.08% 116.29% at 11.17% 95.21%, rgba(39, 201, 119, 0.15) 0%, rgba(61, 170, 115, 0.25) 41.47%, rgba(39, 201, 119, 0) 100%), rgba(255, 255, 255, 0.08)',
    },
  ]
  return (
    <section className="relative mb-10 after:absolute after:w-[330px] after:h-[330px] after:bottom-[85%] after:right-0 after:bg-reviewsSliderBg after:bg-no-repeat after:bg-[right_center] after:-z-[1]">
      <h2 className="mb-8 text-center font-bold text-XL">Our users love us</h2>
      <div className="md:max-w-content overflow-hidden">
        <Swiper
          spaceBetween={0}
          modules={[Navigation, Pagination, EffectCreative]}
          effect={'creative'}
          grabCursor={true}
          slidesPerView={1.4}
          initialSlide={1}
          watchSlidesProgress={true}
          centeredSlides={true}
          className="reviewSlider"
          creativeEffect={{
            prev: {
              scale: 0.9,
              translate: ['-100%', '0%', 0],
            },
            next: {
              scale: 0.9,
              translate: ['100%', '0%', 0],
            },
          }}
          pagination={{ clickable: true }}
        >
          {items.map((item, index) => (
            <SwiperSlide key={index}>
              <div className="w-full h-full flex justify-center items-center">
                <div
                  className="flex flex-col justify-start items-center gap-4 p-6 rounded-4xl max-w-[291px]"
                  style={{ background: item.gradientBg }}
                >
                  <svg width={20} viewBox="0 0 21 20" color={item.quotesColor}>
                    <use href="/svg/sprite.svg#commas"></use>
                  </svg>
                  <p className="text-ML text-center">{item.review}</p>
                  <div className="flex flex-row items-center gap-2">
                    <figure className="relative w-10 h-[31.59px]">
                      <img
                        src={item.author.img}
                        alt={item.author.text}
                        className="absolute max-w-full block object-contain"
                      />
                    </figure>

                    <div className="flex flex-col">
                      <p className="text-S tracking-[1px] uppercase font-semibold">
                        {item.author.text}
                      </p>
                      <p className="flex flex-row items-center gap-1 mt-0.5 text-white/50 text-SM font-semibold">
                        <svg viewBox="0 0 13 12" width={12}>
                          <use href="/svg/sprite.svg#planet"></use>
                        </svg>
                        <span>{item.publishedAt}</span>
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
    </section>
  )
}

export default ReviewSlider
